<template>
  <div class="space-detail">
    <div v-if="active == true">
      <v-tabs v-model="tab">
        <v-tab key="detail">Detalle</v-tab>
        <v-tab key="shared">Compartido</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="detail">
          <div class="detail-f">
            <div class="detail-type">
              <div class="ctn-input-type">
                <p class="input-l">Nombre del {{ typeFile }}</p>
                <p class="input-d">{{ item.name }}</p>
              </div>
              <div class="ctn-input-type">
                <p class="input-l">Descripción</p>
                <p v-if="item.description != ''" class="input-d">Ninguna</p>
                <p v-else class="input-d">{{ item.description }}</p>
              </div>
              <div class="ctn-input-type">
                <p class="input-l">Actualizado</p>
                <p class="input-d">{{ item.updateAt | formatDate }}</p>
              </div>
              <div class="ctn-input-type">
                <p class="input-l">Creado</p>
                <p class="input-d">{{ item.createdAt | formatDate }}</p>
              </div>
              <div class="ctn-input-type">
                <p class="input-l">Estado</p>
                <p v-if="item.block == true" class="input-d">
                  <v-icon class="lock">mdi-lock</v-icon>
                  <span>Bloqueado</span>
                </p>
                <p v-else class="input-d">
                  <v-icon class="unlock">mdi-lock-open</v-icon>
                  <span>Desbloqueado</span>
                </p>
              </div>
              <div class="ctn-input-type">
                <p class="input-l">Creado por:</p>
                <p class="input-d">{{ item.user.email }}</p>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item key="shared">
          <div class="detail-f">
            <div v-if="item.shared.length >= 1" class="shared-user">
              <div class="help-info">
                <p class="help-info-title">Importante</p>
                <p class="help-info-desc">
                  Revisa la fecha de <b>caducidad del link</b>, si tu invitación
                  no se ha aceptado.
                </p>
              </div>

              <p class="desc">Invitaciones Aceptadas:</p>
              <ul v-for="el in item.shared" :key="el._id">
                <li>
                  <div class="box-user">
                    <div class="box-user-icon">
                      <img src="../../assets/img/user-male.svg" alt="" />
                    </div>
                    <div class="box-user-name">
                      <p class="name">{{ el.user.email }}</p>
                      <p class="access">{{ el.leave }}</p>
                    </div>
                    <v-menu
                      v-if="isLogin._id == item.user._id"
                      class=""
                      content-class="menu-created"
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon class="btn-m-tab" v-bind="attrs" v-on="on">
                          <v-icon>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="el.user._id != item.user._id">
                          <v-btn @click="editAccess(el)" class="btn-me">
                            <v-icon class="folder">mdi-pencil</v-icon>
                            <span>Editar permiso</span>
                          </v-btn>
                        </v-list-item>
                        <v-list-item v-if="el.user._id != item.user._id">
                          <v-btn @click="deleteAccess(el)" class="btn-me">
                            <v-icon class="folder">mdi-delete</v-icon>
                            <span>Quitar acceso</span>
                          </v-btn>
                        </v-list-item>
                        <v-list-item v-if="el.user._id === item.user._id">
                          <v-btn class="btn-me">
                            <span>No tienes opciones activas</span>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </li>
              </ul>
              <remove-access
                :item="item._id"
                :shared="itemObjct"
                :visible="accessflag"
                @close="accessflag = false"
              ></remove-access>
              <edit-access
                :item="item"
                :shared="itemObjct"
                :visible="shareEditflag"
                @close="shareEditflag = false"
              ></edit-access>
            </div>
            <div v-else class="detail-nofound">
              <div class="icon-detail">
                <!-- <img src="../../assets/img/i-folder.svg" alt="" /> -->
              </div>
              <p>No se ha invitado a nadie a este espacio.</p>
            </div>
            <div v-if="this.sharedInvite != false" class="shared-user">
              <p class="desc">Invitaciones pendientes:</p>
              <ul v-for="el in sharedPending" :key="el._id">
                <li>
                  <div class="box-user">
                    <div class="box-user-icon">
                      <img src="../../assets/img/user-male.svg" alt="" />
                    </div>
                    <div class="box-user-name">
                      <p class="name">{{ el.email }}</p>
                      <p class="access">{{ el.access }}</p>
                    </div>
                    <v-menu
                      v-if="isLogin._id == item.user._id"
                      class=""
                      content-class="menu-created"
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon class="btn-m-tab" v-bind="attrs" v-on="on">
                          <v-icon>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-btn @click="deleteInvited(el)" class="btn-me">
                            <v-icon class="folder">mdi-delete-outline</v-icon>
                            <span>Eliminar</span>
                          </v-btn>
                        </v-list-item>
                        <!-- <v-list-item>
                          <v-btn @click="test(el)" class="btn-me">
                            <v-icon class="folder">mdi-folder</v-icon>
                            <span>Editar permiso</span>
                          </v-btn>
                        </v-list-item> -->
                      </v-list>
                    </v-menu>
                  </div>
                  <div class="box-link">
                    <p class="caduce">
                      el link caduca:
                      <span>
                        {{ el.tokenShared.dateToken | formatDateShort }}
                      </span>
                    </p>
                    <v-text-field
                      outlined
                      label="link de la invitación"
                      :value="`https://luworkspace.lubumas.com/shared/${el.tokenShared.token}`"
                    ></v-text-field>
                    <v-btn
                      @click="
                        copyInviteUrl(
                          `https://luworkspace.lubumas.com/shared/${el.tokenShared.token}`
                        )
                      "
                    >
                      copiar invitación
                    </v-btn>
                  </div>
                </li>
              </ul>
              <remove-invite
                :item="item._id"
                :shared="itemObjct"
                :visible="inviteflag"
                @close="inviteflag = false"
              ></remove-invite>
            </div>
            <div v-else class="detail-nofound">
              <div class="icon-detail">
                <!-- <img src="../../assets/img/i-folder.svg" alt="" /> -->
              </div>
              <p>No tiene invitaciones pendientes</p>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else class="detail-nofound">
      <div class="icon-detail">
        <img src="../../assets/img/i-folder.svg" alt="" />
      </div>
      <p>Seleccione un archivo o una carpeta para ver los detalles.</p>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import RemoveInvite from "@/components/space/RemoveInvite.vue";
import RemoveAccess from "@/components/space/SpaceRemoveAccess.vue";
import SpaceEditShared from "@/components/space/SpaceEditShared.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "FolderDetail",
  props: ["item", "typeFile"],
  components: {
    "remove-invite": RemoveInvite,
    "remove-access": RemoveAccess,
    "edit-access": SpaceEditShared
  },
  data() {
    return {
      tab: "detail",
      itemObjct: {},
      inviteflag: false,
      shareEditflag: false,
      accessflag: false,
      sharedPending: []
    };
  },
  async created() {
    this.$root.$on("reload", async () => {
      await this.query();
    });

    this.$root.$on("updateAccess", async (el) => {
      this.item.shared.map((a) => {
        return a._id === el._id ? (a.leave = el.leave) : a;
      });
      this.$root.$emit("reload");
      // eliminar del itemObject.shared
    });

    this.$root.$on("updateShared", async (el) => {
      _.remove(this.item.shared, {
        _id: el._id
      });
      this.$root.$emit("reload");
      // eliminar del itemObject.shared
    });
  },

  methods: {
    ...mapActions(["queryShared"]),
    // test(el) {
    //   console.log("test", el._id);

    //   _.remove(this.item.shared, {
    //     _id: el._id
    //   });
    //   this.$root.$emit("reload");
    // },
    async query() {
      this.sharedPending = await this.queryShared(this.item._id);
    },
    editAccess(param) {
      this.itemObjct = Object.assign({}, param);
      this.shareEditflag = true;
    },
    deleteAccess(param) {
      this.itemObjct = Object.assign({}, param);
      this.accessflag = true;
    },
    deleteInvited(param) {
      this.itemObjct = Object.assign({}, param);
      this.inviteflag = true;
    },
    copyInviteUrl(param) {
      // copy in navigator clipboard
      navigator.clipboard.writeText(param);
      this.$root.$emit("snackbar", {
        status: 200,
        visible: true,
        text: `La invitación se ha copiado en el portapapeles.`
      });
      //console.log("copy" + param);
    }
  },
  computed: {
    ...mapGetters(["isLogin"]),
    sharedInvite() {
      if (this.sharedPending.length >= 1) {
        return true;
      } else {
        return false;
      }
    },
    active() {
      if (Object.keys(this.item).length >= 1) {
        this.query();
        return true;
      } else {
        return false;
      }
    }
  },

  filters: {
    formatDateShort: (value) => {
      if (value) {
        return moment(value).format("LL");
      }
      return "-";
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("LLL");
      }
      return "-";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/base.scss";
</style>
